module.exports = new __parcel__URL__("BrickBoard.07f48119.jpeg").toString();